import React from 'react';

import './negative-margin.scss';
import { IClassNames, makeClassNames } from '../../../utils/styles';

const classNames = (): IClassNames =>
  makeClassNames({
    negativeMargin: 'negative-margin',
  });

/** Adds margin-top: -15px */
const NegativeMargin: React.FC = () => {
  const cn = classNames();
  return <div className={cn.negativeMargin} />;
};

export default NegativeMargin;
